import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled, { keyframes } from "styled-components";

const fadeSlide = keyframes`
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Container = styled.div`
  background-color: var(--accent-100);
  width: 100%;
  max-width: 100vw;
  height: var(--navbar-mini);
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Wrapper = styled.header`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    max-width: var(--max-width-container);
    padding: 0;
    display: grid; /* Prikazuje sve elemente odjednom na širim ekranima */
    grid-template-columns: repeat(3, 1fr);
  }
`;
const GridItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--bg-100);
  font-size: 0.72rem;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
  animation: ${fadeSlide} 0.35s ease;

  @media (min-width: 768px) {
    height: 60%;
    position: relative;

    &:not(:last-child)::after {
      content: "";
      position: absolute;
      right: 0;
      top: 0;
      height: 100%;
      width: 1px;
      background-color: rgba(255, 255, 255, 0.25);
    }
  }
`;

const IconWrap = styled.svg`
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  color: var(--bg-100);

  @media (min-width: 768px) {
    width: 18px;
    height: 18px;
  }
`;

const icons = {
  delivery: (
    <IconWrap
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="1" y="3" width="15" height="13" />
      <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
      <circle cx="5.5" cy="18.5" r="2.5" />
      <circle cx="18.5" cy="18.5" r="2.5" />
    </IconWrap>
  ),
  selection: (
    <IconWrap
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="7" height="7" />
      <rect x="14" y="3" width="7" height="7" />
      <rect x="14" y="14" width="7" height="7" />
      <rect x="3" y="14" width="7" height="7" />
    </IconWrap>
  ),
  service: (
    <IconWrap
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
      <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3v5zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3v5z" />
    </IconWrap>
  ),
};

const HeaderSlider = () => {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const sliderItems = [
    { id: 1, icon: icons.delivery, text: t("HEADER_SLIDER.DELIVERY_TO_AUSTRIA") },
    { id: 2, icon: icons.selection, text: t("HEADER_SLIDER.BIG_SELECTION") },
    { id: 3, icon: icons.service, text: t("HEADER_SLIDER.BEST_CUSTOMER_SERVICE") },
  ];

  // Provera da li je ekran mobilni ili desktop
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Menja slajd svakih 2 sekunde samo na mobilnom
  useEffect(() => {
    if (isMobile) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) =>
          prevIndex === sliderItems.length - 1 ? 0 : prevIndex + 1
        );
      }, 5000);
      return () => clearInterval(interval); // Očisti interval na unmount
    }
  }, [isMobile]);

  return (
    <Container>
      <Wrapper>
        {isMobile ? (
          <GridItem key={sliderItems[currentIndex].id}>
            {sliderItems[currentIndex].icon}
            {sliderItems[currentIndex].text}
          </GridItem>
        ) : (
          sliderItems.map((item) => (
            <GridItem key={item.id}>
              {item.icon}
              {item.text}
            </GridItem>
          ))
        )}
      </Wrapper>
    </Container>
  );
};

export default HeaderSlider;
